import React, { memo } from 'react';
import { useDevice } from '../hooks/useDevice';
import Layout from './Layout';
import MobileLayout from './MobileLayout';
import SupportFab from './SupportFab';

interface AdaptiveLayoutProps {
  children: React.ReactNode;
}

const AdaptiveLayout: React.FC<AdaptiveLayoutProps> = memo(({ children }) => {
  const { isMobile, isTablet } = useDevice();

  // Tablet e mobile condividono layout compatto con menu hamburger completo.
  if (isMobile || isTablet) {
    return (
      <>
        <MobileLayout>{children}</MobileLayout>
        <SupportFab />
      </>
    );
  }

  // Use desktop layout for larger screens
  return (
    <>
      <Layout>{children}</Layout>
      <SupportFab />
    </>
  );
});

AdaptiveLayout.displayName = 'AdaptiveLayout';

export default AdaptiveLayout;
